import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import deeptiPicture from '../assets/images/deepti_picture_1.png';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={deeptiPicture} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://www.linkedin.com/in/deepti-dalawai/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Deepti Dalawai</h1>
          <p>Psychologist  | UX researcher | Counsellor</p>

          <div className="mobile_social_icons">
            <a href="https://www.linkedin.com/in/deepti-dalawai/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;